import { DateTime } from 'luxon';
import { SisMediaSetting } from 'src/app/webreport/domain/sismedia-setting.model';

export class SisMediaSettingAdapter {
  static adapt(item: any): SisMediaSetting | null {
    if (!item) {
      return null;
    }

    return {
      tenantGuid: item.tenantGuid,
      winterSeasonStartDate: DateTime.fromISO(item.winterSeasonStartDate).startOf('day').toJSDate(),
      winterSeasonEndDate: DateTime.fromISO(item.winterSeasonEndDate).startOf('day').toJSDate(),
      liftsOpenFrom: item.liftsOpenFrom,
      liftsOpenTo: item.liftsOpenTo,
    };
  }
}
